import { getTopPages } from "common/services/analytics.service";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  // Dropdown,
  // DropdownItem,
  // DropdownMenu,
  // DropdownToggle,
} from "reactstrap";

const TopPages = () => {
  const [isTopPageDropdown, setTopPageDropdown] = useState<boolean>(false);
  const toggleDropdown = () => {
    setTopPageDropdown(!isTopPageDropdown);
  };
  //   const topPages = [
  //     {
  //       page: "Home",
  //       active: 100,
  //       user: 100,
  //     },
  //     {
  //       page: "Home",
  //       active: 100,
  //       user: 100,
  //     },
  //   ];
  const [period, setPeriod] = useState<string>("all");
  const [topPages, setTopPages] = useState<any>([]);
  useEffect(() => {
    const fetchTopPages = async () => {
      let typeOfRequest = "";
      if (period === "all") typeOfRequest = "all";
      else if (period === "lastweek") typeOfRequest = "pastweek";
      else if (period === "lastmonth") typeOfRequest = "pastmonth";
      else if (period === "last6months") typeOfRequest = "past6months";
      else if (period === "lastyear") typeOfRequest = "pastyear";

      const response: any = await getTopPages({ typeOfRequest });
      if (response && response.data) {
        setTopPages(response.data);
      }
    };
    fetchTopPages();
  }, []);

  return (
    <React.Fragment>
      <Col xl={4} md={6}>
        <Card className="card-height-100">
          <CardHeader className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">Top Pages</h4>
            <div className="flex-shrink-0">
              {/* <Dropdown
                isOpen={isTopPageDropdown}
                toggle={toggleDropdown}
                className="card-header-dropdown"
              >
                <DropdownToggle
                  tag="a"
                  className="text-reset dropdown-btn"
                  role="button"
                >
                  <span className="text-muted fs-16">
                    <i className="mdi mdi-dots-vertical align-middle"></i>
                  </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <DropdownItem onClick={() => setPeriod("lastweek")}>
                    Last Week
                  </DropdownItem>
                  <DropdownItem onClick={() => setPeriod("lastmonth")}>
                    Last Month
                  </DropdownItem>
                  <DropdownItem onClick={() => setPeriod("last6months")}>
                    Last 6 Months
                  </DropdownItem>
                  <DropdownItem onClick={() => setPeriod("lastyear")}>
                    Last Year
                  </DropdownItem>
                  <DropdownItem onClick={() => setPeriod("all")}>
                    All Time
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown> */}
            </div>
          </CardHeader>
          <CardBody>
            <div className="table-responsive table-card">
              <table className="table align-middle table-borderless table-centered table-nowrap mb-0">
                <thead className="text-muted table-light">
                  <tr>
                    <th scope="col" style={{ width: "62" }}>
                      Page
                    </th>
                    <th scope="col">Visits</th>
                    <th scope="col">Users (%)</th>
                  </tr>
                </thead>
                <tbody>
                  {(topPages || []).map((item: any, index: any) => (
                    <tr key={index}>
                      <td>
                        <Link to={item.pageUrl}>{item.pageName}</Link>
                      </td>
                      <td>{item.visits}</td>
                      <td>{item.percentUsersVisited}%</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default TopPages;
